import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardGeneralComponent } from './dashboard-general.component';
// Sirena-specific route removed: mostrar solo el listado generico 'Vivos'

const routes: Routes = [
  {
    path: '',
    title: 'Dashboard',
    component: DashboardGeneralComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardGeneralRoutingModule {}
